import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { DEFAULT_CONTENT } from "@/lib/content";
import { richBlocks } from "@/lib/richtext";
import ThemeToggle from "@/components/ThemeToggle";

const LOGO = "/logo.webp";

const TITLES = {
  impressum: "Impressum",
  datenschutz: "Datenschutzerklärung",
};

export default function Legal({ kind }) {
  const [content, setContent] = useState(DEFAULT_CONTENT);

  useEffect(() => {
    api.get("/content").then((r) => {
      if (r.data && Object.keys(r.data).length) setContent({ ...DEFAULT_CONTENT, ...r.data });
    }).catch(() => {});
  }, []);

  const title = TITLES[kind] || "";
  const text = (kind === "impressum" ? content.impressum_text : content.datenschutz_text) || "";

  return (
    <div className="min-h-screen bg-page flex flex-col">
      <header className="fixed top-0 inset-x-0 z-50">
        <div className="mx-auto max-w-7xl px-6 md:px-10">
          <div className="mt-4 flex items-center justify-between rounded-full border border-linetone bg-panel/85 backdrop-blur-md px-5 py-2.5">
            <Link to="/" data-testid="legal-logo-link" className="flex items-center gap-3">
              <img src={LOGO} alt="Tonpoesie" className="h-10 w-10 rounded-full object-cover" />
              <span className="font-serif text-2xl leading-none tracking-tight text-ink">Tonpoesie</span>
            </Link>
            <div className="flex items-center gap-4">
              <Link to="/" className="text-sm text-inkmuted hover:text-ink transition-colors">
                Zur Startseite
              </Link>
              <ThemeToggle className="p-2 text-inkmuted hover:text-ink" />
            </div>
          </div>
        </div>
      </header>

      <main className="flex-1 pt-40 pb-24 md:pt-48">
        <div className="mx-auto max-w-3xl px-6 md:px-10">
          <h1 className="font-serif text-ink text-4xl sm:text-5xl tracking-tight mb-10">{title}</h1>
          {text.trim() ? (
            <div className="whitespace-pre-line text-inkmuted leading-relaxed" data-testid="legal-text">
              {richBlocks(text)}
            </div>
          ) : (
            <p className="text-inkmuted italic" data-testid="legal-empty">Diese Seite ist noch nicht befüllt.</p>
          )}
        </div>
      </main>

      <footer className="bg-olive-ink text-bone/60 py-8">
        <div className="mx-auto max-w-7xl px-6 md:px-10 flex flex-col md:flex-row md:items-center justify-between gap-2 text-xs">
          <span>© {new Date().getFullYear()} Tonpoesie Keramik Studio.</span>
          <div className="flex gap-4">
            <Link to="/impressum" className="hover:text-sage transition-colors">Impressum</Link>
            <Link to="/datenschutz" className="hover:text-sage transition-colors">Datenschutz</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
